import React, { Component } from "react";
import NavBar from "../../../_components/common/Navbar";
import DynamicForm from "../../../_components/common/Form";
import { connect } from "react-redux";

import Aux from "../../../_components/common/Hoc";
import {
  accountInformation,
  basicInformation,
  additionalInformation,
  dobInformation,
} from "./userDetailsFormData";

import {
  countryListActions,
  userProfileAction,
  demographicDataAction,
  updateBasicProfileAction,
  updateAccountInfoAction,
  updateAdditionalInfoAction,
  updateDobInfoAction,
} from "../../../_actions";
import { CommonBreadCrumb } from "../../../_components/common/CommonBreadCrumb";





class UserDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closeForm: true,
      basicCloseForm: true,
      dobCloseForm: true,
      additionalCloseForm: true,
      basicInfoFd: [],
      date: "",
      dobControl: false,
    };
  }

  componentDidUpdate(prevProp) {
    if (
      prevProp.userProfileRootResponse !== this.props.userProfileRootResponse
    ) {
      if (this.props.userProfileRootResponse !== "") {
        dobInformation.map((info) => {
          if (info.key === "year") {
            info.validation.server_time =
              this.props.userProfileRootResponse.server_time;
            info.validation.maxYear =
              new Date(
                this.props.userProfileRootResponse.server_time
              ).getYear() + 1900;
          }
        });
      }
    }
  }

  componentDidMount() {
    this.props.dispatch(countryListActions.getCountries());
    this.props.dispatch(userProfileAction.getUserProfileHandler());
    this.props.dispatch(demographicDataAction.getDemographicDataHandler());
  }

  accountInformationAction(data) {
    const formData = data.sellerData;

    this.setState({
      closeForm: true,
    });
    const fd = {
      country: formData.country === "" ? null : formData.country,
      full_name: formData.full_name,
      gender: formData.gender,
      short_name: formData.short_name,
    };
    this.props.dispatch(updateAccountInfoAction.updateAccountInfoHandler(fd));
  }

  dobInformationAction(data) {


    this.setState({
      dobError: false,
      dobCloseForm: true,
    });
    if (this.state.dobControl === false) {
      const fd = {
        date_of_birth:
          data.sellerData.year.toString() +
          "-" +
          [
            +data.sellerData.month > 9
              ? data.sellerData.month.toString()
              : "0" + data.sellerData.month,
          ] +
          "-" +
          [
            [
              +data.sellerData.day > 9
                ? data.sellerData.day.toString()
                : "0" + data.sellerData.day,
            ],
          ],
      };
   
      if (fd.date_of_birth !== "0-0-0")
        this.props.dispatch(updateDobInfoAction.updateDobInfoHandler(fd));
    }
    if (this.state.dobControl === true) {
      const fd = {
        date_of_birth: null,
      };
      if (fd.date_of_birth !== "0-0-0")
        this.props.dispatch(updateDobInfoAction.updateDobInfoHandler(fd));
    }
  }

  basicInformationAction(data) {
    const formData = data.sellerData;


    this.setState({
      basicCloseForm: true,
    });
    const fd = {
      city: formData.user_details__city,
      alter_email: formData.user_details__alter_email,
      occupation: formData.user_details__occupation,

      industry: formData.user_details__industry__id,
      qualification: formData.user_details__qualification__id,
      marital_status: formData.user_details__marital_status_id,
      tenure_in_company: formData.user_details__tenure_in_company,
      work_experience: formData.user_details__work_experience,
      designation: formData.user_details__designation,
    
    };

    this.props.dispatch(updateBasicProfileAction.updateBasicProfileHandler(fd));
  }

  additionalInformationAction(data) {
    const formData = data.sellerData;
  
    this.setState({
      additionalCloseForm: true,
    });

    const fd = {
      family_type: formData.user_details__family_type,
      hobbies: formData.user_details__hobbies,
      annual_income: formData.user_details__annual_income,
      no_of_children: formData.user_details__no_of_children,
      keep_posted_on_discoverself:
        formData.user_details__keep_posted_on_discoverself,
      add_to_discoverself_blog: formData.user_details__add_to_discoverself_blog,
      previous_assesment_list: formData.user_details__previous_assesment_list,
    };
  
    this.props.dispatch(
      updateAdditionalInfoAction.updateAdditionalInfoHandler(fd)
    );
  }

  onClickCancel = () => {
    this.setState({
      closeForm: true,
      basicCloseForm: true,
      dobCloseForm: true,
      additionalCloseForm: true,
    });
  
  };

  onClickAccountInfo = () => {
    this.setState({
      closeForm: false,
      basicCloseForm: true,
      dobCloseForm: true,
      additionalCloseForm: true,
    });
  };

  onClickBasicInfo = () => {
    this.setState({
      basicCloseForm: false,
      closeForm: true,
      dobCloseForm: true,
      additionalCloseForm: true,
    });
  };

  onClickDobInfo = () => {
    this.setState({
      dobCloseForm: false,
      closeForm: true,
      basicCloseForm: true,
      additionalCloseForm: true,
    });
  };
  onClickAdditionalInfo = () => {
    this.setState({
      additionalCloseForm: false,
      closeForm: true,
      basicCloseForm: true,
      dobCloseForm: true,
    });
  };

  getDob = (data) => {
  
    const dateSplit = data.split("-");
    dateSplit[1] =
      dobInformation[1].elementConfig.options[+dateSplit[1] - 1].label;
    return dateSplit[2] + "-" + dateSplit[1] + "-" + dateSplit[0];
  };

  getSeperateDob = (data, i) => {
    const dateSplit = data.split("-");
    return +dateSplit[i];
  };

  onChangeRadio = (ev) => {
    if (ev === "blank") {
      dobInformation.map((element, i) => {
        element.valid = true;
      });
      this.setState({
        dobControl: true,
      });
    } else {
      this.setState({
        dobControl: false,
      });
    }
  };

  render() {
    const {
      countries,
      userProfileResponse,
      userProfileLoading,
      demographicDataResponse,
    } = this.props;

    accountInformation.map(function (element) {
      if (element.key === "country") {
        element.elementConfig.options = countries;
      }
    });

    accountInformation.map((element, i) => {
      element.value = userProfileResponse[element.key]
        ? userProfileResponse[element.key]
        : "";
      if (element.validation.required === false) {
        element.valid = true;
      } else if (element.value.length !== 0) {
        element.valid = true;
      }
    });

    dobInformation.map((element, i) => {
      if (element.key === "day") {
        element.elementConfig.options = [];
        for (let i = 1; i <= 31; i++) {
          element.elementConfig.options.push({ day: i, id: i });
        }
        element.value = userProfileResponse.date_of_birth
          ? this.getSeperateDob(userProfileResponse.date_of_birth, 2)
          : "";
      }
      if (element.key === "month") {
        element.value = userProfileResponse.date_of_birth
          ? this.getSeperateDob(userProfileResponse.date_of_birth, 1)
          : "";
      }
      if (element.key === "year") {
        element.value = userProfileResponse.date_of_birth
          ? this.getSeperateDob(userProfileResponse.date_of_birth, 0)
          : "";
      }
      if (element.validation.required === false) {
        element.valid = true;
      }
    });

    additionalInformation.map((element, i) => {
      element.value = userProfileResponse[element.key]
        ? userProfileResponse[element.key]
        : "";

      element.valid = true;
    });
    basicInformation.map((element, i) => {
      basicInformation.map((element, i) => {
        if (element.elementConfig.label.toUpperCase() === "INDUSTRY") {
          for (let i in this.props.demographicDataResponse) {
            if (
              this.props.demographicDataResponse[i].demographic_type_name ===
              "INDUSTRY"
            ) {
              element.elementConfig.options =
                this.props.demographicDataResponse[i].demographics.map(
                  (data, i) => {
                    return {
                      user_details__industry__demographic_name:
                        data.demographic_name,
                      id: data.id,
                    };
                  }
                );
            }
          }
        }

        if (element.elementConfig.label.toUpperCase() === "QUALIFICATION") {
          for (let i in this.props.demographicDataResponse) {
            if (
              this.props.demographicDataResponse[i].demographic_type_name ===
              "QUALIFICATION"
            ) {
              element.elementConfig.options =
                this.props.demographicDataResponse[i].demographics.map(
                  (data, i) => {
                    return {
                      user_details__qualification__demographic_name:
                        data.demographic_name,
                      id: data.id,
                    };
                  }
                );
            }
          }
        }
        element.value = this.props.userProfileResponse[element.key]
          ? this.props.userProfileResponse[element.key]
          : "";
        if (element.validation.required === false) {
          element.valid = true;
        } else if (element.value.length !== 0) {
          element.valid = true;
        }
      });
    });

    return (
      <div>
        <NavBar />

        <div className="container custom-container my-5">
          <div>
            <CommonBreadCrumb
              data={[
                {
                  link: "/app/dashboard",
                  name: "DASHBOARD",
                },
                {
                  link: "",
                  name: "USER DETAILS",
                },
              ]}
            />
          </div>

          <div>
            <div className="bg-green rounded-top position-relative d-flex flex-row flex-wrap justify-content-between align-items-center my-3 py-1">
              <p className=" text-uppercase py-2 pl-3 text-white mb-0 quattrocentosans regular">
                {" "}
                EMAIL{" "}
              </p>
              {userProfileLoading && (
                <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position "></i>
              )}
            </div>
            <div className="ml-3">
              <p className="quattrocentosans bold">
                {userProfileResponse.email}
              </p>
            </div>
          </div>

          <div>
            {this.state.closeForm === true && (
              <div className="bg-green rounded-top position-relative d-flex flex-row flex-wrap justify-content-between align-items-center my-3 py-1">
                <div>
                  <p className=" text-uppercase py-2 pl-3 text-white mb-0 quattrocentosans regular">
                    {" "}
                    Account Information
                  </p>
                </div>

                {!userProfileLoading && (
                  <div>
                    <i
                      onClick={this.onClickAccountInfo}
                      className="text-white pr-3 fas fa-pencil-alt cursor-pointer"
                    ></i>
                  </div>
                )}

                {userProfileLoading && (
                  <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position "></i>
                )}
              </div>
            )}

            {this.state.closeForm === true && (
              <div className="ml-md-3 my-2 ml-0">
                <div className="d-flex flex-row flex-wrap">
                  {!userProfileLoading &&
                    accountInformation.map((data, i) => {
                      return (
                        <Aux key={i}>
                          {data.elementConfig.label === "Name" && (
                            <div className="col-12 px-0">
                              <h1 className="bold text-secondary text-capitalize">
                                {userProfileResponse[data.elementConfig.name]}
                              </h1>
                            </div>
                          )}
                          {data.elementConfig.label !== "Name" && (
                            <Aux>
                              <div className="col-md-4 col-6 px-0">
                                <p className="quattrocentosans bold">
                                  {data.elementConfig.label}
                                  {data.validation.required && (
                                    <span className="text-danger">*</span>
                                  )}
                                </p>
                              </div>
                              <div className="col-md-8 col-6 px-0">
                                {data.key === "gender" && (
                                  <p
                                    className={
                                      userProfileResponse[
                                        data.elementConfig.name
                                      ] === ""
                                        ? "text-muted"
                                        : ""
                                    }
                                  >
                                    {userProfileResponse[
                                      data.elementConfig.name
                                    ] === ""
                                      ? "Add " + data.elementConfig.label
                                      : userProfileResponse[
                                          data.elementConfig.name
                                        ] === "1"
                                      ? "Male"
                                      : userProfileResponse[
                                          data.elementConfig.name
                                        ] === "2"
                                      ? "Female"
                                      : "Others"}
                                  </p>
                                )}
                                {data.key !== "gender" && (
                                  <p
                                    className={
                                      userProfileResponse[
                                        data.elementConfig.name ===
                                        "country_name"
                                          ? "country__country_name"
                                          : data.elementConfig.name
                                      ]
                                        ? ""
                                        : "text-muted"
                                    }
                                  >
                                    {userProfileResponse[
                                      data.elementConfig.name === "country_name"
                                        ? "country__country_name"
                                        : data.elementConfig.name
                                    ]
                                      ? userProfileResponse[
                                          data.elementConfig.name ===
                                          "country_name"
                                            ? "country__country_name"
                                            : data.elementConfig.name
                                        ]
                                      : userProfileResponse[
                                          data.elementConfig.name
                                        ] === null ||
                                        userProfileResponse[
                                          data.elementConfig.name
                                        ] === undefined
                                      ? "Add " + data.elementConfig.label
                                      : ""}
                                  </p>
                                )}
                              </div>
                            </Aux>
                          )}
                        </Aux>
                      );
                    })}
                </div>
              </div>
            )}
            {this.state.closeForm === false && (
              <div className="my-3">
                <DynamicForm
                  formName={"user-details"}
                  headerName="ACCOUNT INFORMATION"
                  data={accountInformation}
                  action={this.accountInformationAction.bind(this)}
                  selects={["gender", "country_name"]}
                  cancel={this.onClickCancel.bind(this)}
                  selectKey={["id", "id"]}
                />
              </div>
            )}
          </div>

          <div>
            {this.state.dobCloseForm === true && (
              <div className="bg-green rounded-top position-relative d-flex flex-row flex-wrap justify-content-between align-items-center my-3 py-1">
                <div>
                  <p className=" text-uppercase py-2 pl-3 text-white mb-0 quattrocentosans regular">
                    Date of Birth Information
                  </p>
                </div>
                {!userProfileLoading && (
                  <div>
                    <i
                      onClick={this.onClickDobInfo}
                      className="text-white pr-3 fas fa-pencil-alt cursor-pointer"
                    ></i>
                  </div>
                )}

                {userProfileLoading && (
                  <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position "></i>
                )}
              </div>
            )}
            {this.state.dobCloseForm === true && !userProfileLoading && (
              <div className="ml-md-3 ml-0">
                <div className="d-flex flex-row flex-wrap">
                  <div className="col-md-4 col-6 px-0">
                    <p className="quattrocentosans bold">Date of Birth</p>
                  </div>
                  <div className="col-md-8 col-6 px-0">
                    {
                      <p
                        className={
                          userProfileResponse.date_of_birth === null
                            ? "text-muted"
                            : ""
                        }
                      >
                        {userProfileResponse.date_of_birth
                          ? this.getDob(userProfileResponse.date_of_birth)
                          : userProfileResponse.date_of_birth === null ||
                            userProfileResponse.date_of_birth === undefined ||
                            userProfileResponse.date_of_birth === ""
                          ? "Add Date of Birth"
                          : ""}
                      </p>
                    }
                  </div>
                </div>
              </div>
            )}

            {this.state.dobCloseForm === false && (
              <div className="my-3">
                <DynamicForm
                  formName={"user-details"}
                  headerName="DATE OF BIRTH INFORMATION"
                  data={dobInformation}
                  action={this.dobInformationAction.bind(this)}
                  selects={["month", "day"]}
                  cancel={this.onClickCancel.bind(this)}
                  selectKey={["id", "id"]}
                  onChangeRadio={(ev) => this.onChangeRadio(ev)}
                  dobControl={this.state.dobControl}
                  dobControlBool={true}
                />
              </div>
            )}
          </div>

          <div>
            {this.state.basicCloseForm === true && (
              <div className="bg-green rounded-top position-relative d-flex flex-row flex-wrap justify-content-between align-items-center my-3 py-1">
                <div>
                  <p className=" text-uppercase py-2 pl-3 text-white mb-0 quattrocentosans regular">
                    {" "}
                    Basic Information
                  </p>
                </div>
                {!userProfileLoading && (
                  <div>
                    <i
                      onClick={this.onClickBasicInfo}
                      className="text-white pr-3 fas fa-pencil-alt cursor-pointer"
                    ></i>
                  </div>
                )}

                {userProfileLoading && (
                  <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position "></i>
                )}
              </div>
            )}

            {this.state.basicCloseForm === true && !userProfileLoading && (
              <div className="ml-md-3 my-2 ml-0">
                <div className="d-flex flex-row flex-wrap">
                  {basicInformation.map((data, i) => {
                    return (
                      <Aux key={i}>
                        <div className="col-md-4 col-6 px-0">
                          <p className="quattrocentosans bold">
                            {data.elementConfig.label}
                            {data.validation.required && (
                              <span className="text-danger">*</span>
                            )}
                          </p>
                        </div>
                        <div className="col-md-8 col-6 px-0">
                          {
                            <p
                              className={
                                userProfileResponse[data.elementConfig.name]
                                  ? ""
                                  : "text-muted"
                              }
                            >
                              {userProfileResponse[data.elementConfig.name]
                                ? userProfileResponse[data.elementConfig.name]
                                : userProfileResponse[
                                    data.elementConfig.name
                                  ] === null ||
                                  userProfileResponse[
                                    data.elementConfig.name
                                  ] === 0 ||
                                  userProfileResponse[
                                    data.elementConfig.name
                                  ] === ""
                                ? "Add " + data.elementConfig.label
                                : ""}
                            </p>
                          }
                        </div>
                      </Aux>
                    );
                  })}
                </div>
              </div>
            )}
            {this.state.basicCloseForm === false && (
              <div className="my-3">
                <DynamicForm
                  formName={"user-details"}
                  headerName="BASIC INFORMATION"
                  data={basicInformation}
                  action={this.basicInformationAction.bind(this)}
                  selects={[
                    "user_details__qualification__demographic_name",
                    "user_details__industry__demographic_name",
                    "user_details__marital_status",
                  ]}
                  cancel={this.onClickCancel.bind(this)}
                  selectKey={["id", "id", "id"]}
                />
              </div>
            )}
          </div>

        
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {

  const { loading } = state.countries;
  const { error } = state.countries;
  const countries = !loading && !error ? state.countries.countries : "";

  const { userProfileLoading } = state.getUserProfile;
  const getUserProfileError = state.getUserProfile.error;
  const userProfileResponse =
    !userProfileLoading && !getUserProfileError
      ? state.getUserProfile.data.data.user[0]
      : "";
  const userProfileRootResponse =
    !userProfileLoading && !getUserProfileError
      ? state.getUserProfile.data.data
      : "";

  const { demographicDataLoading } = state.getDemographicData;
  const getDemographicDataError = state.getDemographicData.error;

  const demographicDataResponse =
    !demographicDataLoading && !getDemographicDataError
      ? state.getDemographicData.data.data.results
      : "";

  return {
    loading,
    countries,

    userProfileLoading,
    userProfileResponse,
    userProfileRootResponse,

    demographicDataLoading,
    demographicDataResponse,
  };
}

export default connect(mapStateToProps)(UserDetails);



// WEBPACK FOOTER //
// ./src/_pages/Dashboard/user-details/index.jsx